/* global React, Icon, Card, CardHead, Button, Field, Input, Select, Currency, Badge, EmptyState, Modal, PayDialog, PdfViewer, toast, fmt */
// Employee portal for users invited through payroll employee access.

const ANSATT_BG = [
  { key: 'default', label: 'Plomme', sw: '#A074E0' },
  { key: 'mint', label: 'Mint', sw: '#5FBFA0' },
  { key: 'varm', label: 'Varm', sw: '#F0B45E' },
  { key: 'sky', label: 'Bla', sw: '#7BA7EC' },
  { key: 'rose', label: 'Rose', sw: '#DE8FB4' },
  { key: 'skog', label: 'Skog', sw: '#5E9E7A' },
];

const ansattMoney = (value) => (typeof fmt === 'function' ? fmt(Number(value || 0)) : `${Math.round(Number(value || 0)).toLocaleString(PlummeI18n.intlLocale())} kr`);
const ansattAmount = (value, currency = 'NOK') => {
  const code = String(currency || 'NOK').toUpperCase();
  return code === 'NOK' ? ansattMoney(value) : `${Math.round(Number(value || 0)).toLocaleString(PlummeI18n.intlLocale())} ${code}`;
};
const ansattToday = () => new Date().toISOString().slice(0, 10);
const ANSATT_EXPENSE_CATEGORIES = [
  'Mat og drikke (på reise)',
  'Bompenger',
  'Kollektivtransport',
  'Ferge',
  'Taxi',
  'Fly',
  'Overtidsmat',
  'Parkering',
  'Overnatting',
  'Kontorrekvisita',
  'Aviser, tidsskrifter og bøker',
  'Internett',
  'Telefon',
  'Representasjon',
  'Leiebil på reise',
  'Drivstoff til leiebil',
  'Programvare',
  'Annet',
];
const ANSATT_CURRENCIES = [
  ['NOK', 'Norske kroner'],
  ['EUR', 'Euro'],
  ['USD', 'Amerikanske dollar'],
  ['GBP', 'Britiske pund'],
  ['SEK', 'Svenske kroner'],
  ['DKK', 'Danske kroner'],
  ['CHF', 'Sveitsiske franc'],
  ['ISK', 'Islandske kroner'],
  ['PLN', 'Polske zloty'],
  ['AUD', 'Australske dollar'],
  ['CAD', 'Kanadiske dollar'],
];
const ANSATT_TRAVEL_RATE = 3.5;
const ansattId = (prefix) => `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
const ansattDate = (value) => {
  const iso = String(value || '').slice(0, 10);
  if (!iso) return '-';
  const date = new Date(`${iso}T00:00:00`);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleDateString(PlummeI18n.intlLocale());
};
const ansattInitials = (name) => String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase() || '?';
const ansattStatus = (status) => {
  const normalized = String(status || '').toLowerCase();
  if (normalized === 'included-in-payroll') return ['success', t('km.portal.inPayroll'), 'payroll'];
  if (['approved', 'godkjent', 'paid', 'completed'].includes(normalized)) return ['success', ['paid', 'completed'].includes(normalized) ? t('pay.paidOut') : t('km.portal.approved'), ['paid', 'completed'].includes(normalized) ? 'paid' : 'approved'];
  if (['rejected', 'avvist'].includes(normalized)) return ['error', t('km.portal.rejected'), 'rejected'];
  if (['draft', 'utkast'].includes(normalized)) return ['warning', t('km.portal.draft'), 'draft'];
  if (['active', 'submitted', 'sendt'].includes(normalized)) return ['neutral', t('km.portal.sent'), 'sent'];
  return ['muted', status || t('emp.status.received'), 'other'];
};
const ansattStatusClass = (status) => {
  const value=String(status||'').toLowerCase();
  if(['paid','completed'].includes(value))return 'paid';
  if(value==='included-in-payroll')return 'payroll';
  if(['approved','godkjent'].includes(value))return 'ok';
  if(['rejected','avvist'].includes(value))return 'err';
  if(['draft','utkast'].includes(value))return 'muted';
  return 'warn';
};
const ansattCanDelete = (status) => ['draft', 'utkast', 'submitted', 'sendt', 'rejected', 'avvist'].includes(String(status || '').toLowerCase());
const ansattCanEdit = (status) => ['draft', 'utkast', 'rejected', 'avvist'].includes(String(status || '').toLowerCase());
const ansattCanWithdraw = (status) => ['submitted', 'sendt'].includes(String(status || '').toLowerCase());
const ANSATT_CHANGE_ACTIONS = {
  get submitted() { return t('emp.change.submitted'); },
  get resubmitted() { return t('emp.change.resubmitted'); },
  get updated() { return t('emp.change.updated'); },
  get withdrawn() { return t('emp.change.withdrawn'); },
  get approved() { return t('km.portal.approved'); },
  get rejected() { return t('km.portal.rejected'); },
};
const ansattChangeText = (entry = {}) => {
  const action = ANSATT_CHANGE_ACTIONS[entry.action] || t('emp.change.updated');
  const who = entry.actor === 'employer' ? t('emp.change.byEmployer') : t('emp.change.byYou');
  return t('emp.change.text', { action, who: entry.actorName || who });
};
const ansattChangeStamp = (value) => {
  const date = new Date(String(value || ''));
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString(PlummeI18n.intlLocale(), { dateStyle: 'short', timeStyle: 'short' });
};
const ansattEditedAfterSubmit = (travel = {}) => {
  const submittedAt = String(travel.submittedAt || '');
  if (!submittedAt) return false;
  return (Array.isArray(travel.changeLog) ? travel.changeLog : [])
    .some((entry) => ['updated', 'resubmitted'].includes(entry?.action) && String(entry?.at || '') > submittedAt);
};
const ansattBgKey = (businessId) => `plumme-ansatt-bg::${businessId || 'default'}`;
const getAnsattBg = (businessId) => {
  try { return localStorage.getItem(ansattBgKey(businessId)) || 'default'; } catch (error) { return 'default'; }
};
const setAnsattBg = (businessId, key) => {
  try { localStorage.setItem(ansattBgKey(businessId), key); } catch (error) {}
};
const ansattLineAmount = (line) => Number(line?.amountNet ?? line?.amount ?? line?.payrollAmount ?? line?.mileageAmount ?? 0) || 0;
const ansattTravelPayout = (travel) => [
  ...(travel?.expenseLines || []),
  ...(travel?.mileageLines || []),
  ...(travel?.accommodationLines || []),
].reduce((sum, line) => sum + ansattLineAmount(line), 0);
const ansattYearFrom = (value) => {
  const year = Number(String(value || '').slice(0, 4));
  return Number.isFinite(year) && year > 1900 ? year : 0;
};
const ansattRowYear = (row, keys) => {
  for (const key of keys) {
    const year = ansattYearFrom(row?.[key]);
    if (year) return year;
  }
  return 0;
};
const ansattEmploymentYears = (employee, rows = []) => {
  const current = new Date().getFullYear();
  const rowYears = rows.map(([row, keys]) => ansattRowYear(row, keys)).filter(Boolean);
  const start = ansattYearFrom(employee?.employmentStartDate) || Math.min(...rowYears, current);
  const end = ansattYearFrom(employee?.employmentEndDate) || Math.max(...rowYears, current);
  const years = [];
  for (let year = end; year >= start; year -= 1) years.push(year);
  return years.length ? years : [current];
};

function AnsattMetric({ title, value, sub, tint, onClick, help }) {
  return <div className={`card card-pad ans-portal-metric ans-stat-${tint || 'plum'}${onClick ? ' ans-stat-click' : ''}`} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} {...(help ? { 'data-help-title': title, 'data-help': help } : {})}>
    <div className="row between" style={{ alignItems: 'flex-start' }}>
      <div className="t-h2" style={{ fontSize: 21 }}>{title}</div>
      <span className="ans-stat-n">{value}</span>
    </div>
    <div className="t-sm muted" style={{ fontWeight: 600, marginTop: 6 }}>{sub}</div>
    {onClick && <div className="ans-stat-open">{t('pay.open')}<Icon name="chevRight" size={14} /></div>}
  </div>;
}

function AnsattPortalStatusPill({ status }) {
  const [, label] = ansattStatus(status);
  return <span className={`ans-exp-pill ans-exp-${ansattStatusClass(status)}`}>{label}</span>;
}

function AnsattEmployerSwitcher({ rows, selected, onSelect, clients = [], activeClientId, onSelectClient }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const close = (event) => { if (ref.current && !ref.current.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  return <div className="ans-emp-switch" ref={ref}>
    <button className="ans-emp-btn" onClick={() => setOpen((current) => !current)}>
      <span className="ans-emp-ava">{ansattInitials(selected?.businessName)}</span>
      <span className="ans-emp-meta"><span className="ans-emp-name">{selected?.businessName || t('emp.employerFallback')}</span><span className="ans-emp-role">{selected?.employee?.jobTitle || selected?.employee?.name || t('emp.employeeFallback')}</span></span>
      <Icon name="chevDown" size={16} />
    </button>
    {open && <div className="ans-emp-menu">
      <div className="ans-emp-menu-h">{t('pay.yourEmployers')}</div>
      {rows.map((portal) => {
        const key = `${portal.businessId}-${portal.employee?.id}`;
        const active = selected && key === `${selected.businessId}-${selected.employee?.id}`;
        return <button key={key} className={`ans-emp-item${active ? ' active' : ''}`} onClick={() => { onSelect(key); setOpen(false); }}>
          <span className="ans-emp-ava sm">{ansattInitials(portal.businessName)}</span>
          <span className="ans-emp-meta"><span className="ans-emp-name">{portal.businessName}</span><span className="ans-emp-role">{portal.employee?.jobTitle || portal.employee?.name || t('emp.employeeFallback')}</span></span>
          {active && <Icon name="check" size={16} />}
        </button>;
      })}
      {clients.length ? <React.Fragment>
        <div className="ans-emp-menu-h">{t('pay.yourClients')}</div>
        {clients.map((client) => {
          const active = client.id === activeClientId;
          return <button key={client.id} className={`ans-emp-item${active ? ' active' : ''}`} onClick={() => { onSelectClient && onSelectClient(client.id); setOpen(false); }}>
            <span className="ans-emp-ava sm">{ansattInitials(client.name)}</span>
            <span className="ans-emp-meta"><span className="ans-emp-name">{client.name}</span><span className="ans-emp-role">{client.org ? t('emp.orgNumber', { org: client.org }) : t('emp.accountingClient')}</span></span>
            {active && <Icon name="check" size={16} />}
          </button>;
        })}
      </React.Fragment> : null}
    </div>}
  </div>;
}

function AnsattColor({ businessId, value, onPick }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const close = (event) => { if (ref.current && !ref.current.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const pick = (key) => {
    setAnsattBg(businessId, key);
    onPick(key);
    setOpen(false);
  };
  return <div className="ans-color" ref={ref}>
    <button className="ans-color-btn" onClick={() => setOpen((current) => !current)} title={t('pay.bgForEmployer')}><Icon name="palette" size={20} /></button>
    {open && <div className="ans-color-menu">
      <div className="ans-emp-menu-h">{t('pay.bgColour')}</div>
      <div className="ans-color-grid">{ANSATT_BG.map((theme) => <button key={theme.key} className={`ans-color-opt${value === theme.key ? ' active' : ''}`} onClick={() => pick(theme.key)}>
        <span className="ans-color-sw" style={{ background: theme.sw }} />{t('emp.bg.' + theme.key)}
      </button>)}</div>
    </div>}
  </div>;
}

function useAnsattPortals(refreshKey) {
  const [state, setState] = React.useState({ loading: true, error: '', rows: [] });
  React.useEffect(() => {
    let cancelled = false;
    if (!window.PlummeBackend?.getEmployeePortals) {
      setState({ loading: false, error: t('emp.portalNotConnected'), rows: [] });
      return () => { cancelled = true; };
    }
    setState((current) => ({ ...current, loading: true, error: '' }));
    window.PlummeBackend.getEmployeePortals()
      .then((rows) => {
        if (!cancelled) setState({ loading: false, error: '', rows: Array.isArray(rows) ? rows : [] });
      })
      .catch((error) => {
        if (!cancelled) setState({ loading: false, error: error?.message || t('emp.portalFetchFailed'), rows: [] });
      });
    return () => { cancelled = true; };
  }, [refreshKey]);
  return state;
}

function AnsattAttachmentPicker({ file, onFile, style }) {
  const [open, setOpen] = React.useState(false);
  const [over, setOver] = React.useState(false);
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState('');
  const cameraRef = React.useRef(null);
  const fileRef = React.useRef(null);
  const pickFile = (files) => {
    const nextFile = files?.[0] || null;
    if (nextFile) onFile(nextFile);
    setOpen(false);
  };
  const onInputFile = (event) => {
    pickFile(event.target.files);
    event.target.value = '';
  };
  const clearFile = () => {
    onFile(null);
    setOpen(false);
    setPreviewOpen(false);
  };
  React.useEffect(() => {
    if (!file) {
      setPreviewUrl('');
      setPreviewOpen(false);
      return undefined;
    }
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);
  React.useEffect(() => {
    if (file) return undefined;
    const onPaste = (event) => {
      const files = Array.from(event.clipboardData?.files || []);
      const attachment = files.find((candidate) => candidate.type?.startsWith('image/') || candidate.type === 'application/pdf');
      if (attachment) {
        event.preventDefault();
        onFile(attachment);
      }
    };
    document.addEventListener('paste', onPaste);
    return () => document.removeEventListener('paste', onPaste);
  }, [file, onFile]);
  return <div
    className={`ans-drop${file ? ' on' : ''}${over ? ' over' : ''}`}
    style={style}
    onDragOver={(event) => event.preventDefault()}
    onDragEnter={(event) => { event.preventDefault(); setOver(true); }}
    onDragLeave={() => setOver(false)}
    onDrop={(event) => { event.preventDefault(); setOver(false); pickFile(event.dataTransfer.files); }}
  >
    <input ref={cameraRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }} onChange={onInputFile} />
    <input ref={fileRef} type="file" accept="image/*,application/pdf" style={{ display: 'none' }} onChange={onInputFile} />
    <button type="button" className="ans-drop-main" onClick={() => setOpen((current) => !current)}>
      <Icon name={file ? 'check' : 'upload'} size={22} />
      <span className="ans-drop-t">{file ? file.name : t('emp.attachReceipt')}</span>
      <span className="ans-drop-s">{t('pay.receiptHelp')}</span>
    </button>
    {file && previewUrl && <button
      type="button"
      className="icon-btn sm ghost ans-drop-eye"
      title={t('sharedText.bank.previewVoucher')}
      aria-label={t('sharedText.bank.previewVoucher')}
      onClick={(event) => { event.stopPropagation(); setPreviewOpen(true); }}
    ><Icon name="eye" size={16} /></button>}
    {open && <div className="ans-upload-actions">
      <Button size="sm" icon="camera" onClick={() => cameraRef.current?.click()}>{t('pay.takePhoto')}</Button>
      <Button size="sm" variant="secondary" icon="upload" onClick={() => fileRef.current?.click()}>{t('pay.uploadFile')}</Button>
      {file && <Button size="sm" variant="ghost" onClick={clearFile}>{t('pay.remove')}</Button>}
    </div>}
    {previewOpen && previewUrl && <AnsattAttachmentPreviewModal
      preview={{ src: previewUrl, name: file?.name || t('emp.attachmentFallback'), mimeType: file?.type || '' }}
      onClose={() => setPreviewOpen(false)}
    />}
  </div>;
}

function AnsattExpenseForm({ portal, onClose, onSaved }) {
  const [draft, setDraft] = React.useState({ category: '', date: ansattToday(), paymentMethod: 'private', amount: '', currency: 'NOK', amountNok: '', description: '', file: null, projectId: '', projectBillable: true });
  const projects = Array.isArray(portal?.projects) ? portal.projects : [];
  const toCompany = draft.paymentMethod === 'company-card';
  const [busy, setBusy] = React.useState(false);
  const set = (patch) => setDraft((current) => ({ ...current, ...patch }));
  const amount = window.PlummeMoneyInput.parse(draft.amount, { preferDecimal: true });
  const valid = draft.category && draft.date && draft.description.trim() && Number.isFinite(amount) && amount > 0 && draft.file;
  const submit = async () => {
    if (!valid) {
      toast(t('emp.expenseFillIn'), 'warning');
      return;
    }
    setBusy(true);
    try {
      const attachment = await window.PlummeBackend.uploadEmployeePortalAttachment({
        businessId: portal.businessId,
        employeeId: portal.employee.id,
        file: draft.file,
      });
      await window.PlummeBackend.submitEmployeePortalExpense({
        businessId: portal.businessId,
        employeeId: portal.employee.id,
        category: draft.category,
        date: draft.date,
        description: draft.description.trim(),
        paymentMethod: draft.paymentMethod,
        amount,
        currency: draft.currency, amountNok: window.PlummeMoneyInput.parse(draft.amountNok, { preferDecimal: true }) || undefined,
        attachment,
        projectId: draft.projectId,
        projectBillable: draft.projectBillable,
      });
      toast(toCompany ? t('emp.voucherSentToBookkeeping') : t('emp.expenseSentForApproval'), 'success');
      onSaved();
    } catch (error) {
      toast(error?.message || t('emp.expenseSendFailed'), 'error');
    } finally {
      setBusy(false);
    }
  };
  return <Modal open onClose={onClose} title={t('pay.registerExpense')} max={620} titleRight={<span className="t-sm muted" style={{ fontWeight: 700 }}>{t('pay.receiptRequired')}</span>} footer={<React.Fragment><Button variant="ghost" onClick={onClose}>{t('pay.cancel')}</Button><Button icon="send" disabled={busy || !valid} onClick={submit}>{busy ? t('emp.sending') : toCompany ? t('emp.sendToBookkeeping') : t('emp.sendForApproval')}</Button></React.Fragment>}>
    <div className="col gap-2" style={{ paddingBottom: 4 }}>
    <div className="grid-2 gap-14">
      <Field label={t('pay.category')}><Select value={draft.category} onChange={(event) => set({ category: event.target.value })}>
        <option value="">{t('pay.pickCategory')}</option>
        {ANSATT_EXPENSE_CATEGORIES.map((category) => <option key={category}>{category}</option>)}
      </Select></Field>
      <Field label={t('pay.date')}><Input type="date" value={draft.date} onChange={(event) => set({ date: event.target.value })} /></Field>
      {/* Valget avgjor hele veien videre: la du ut selv, skal du ha pengene
          tilbake gjennom lonn. Betalte foretaket, er det et vanlig kjop som
          skal bokfores — og bilaget gaar til innboksen i stedet. */}
      <Field label={t('pay.paidWith')} hint={toCompany ? t('pay.paidByCompanyHint', 'Bilaget sendes til bokføring, ikke til refusjon.') : t('pay.paidPrivateHint', 'Du får beløpet refundert med lønnen.')} help={t('helpTopics.privatePayment.body')} helpTitle={t('helpTopics.privatePayment.title')}>
        <Select value={draft.paymentMethod} onChange={(event) => set({ paymentMethod: event.target.value })}>
          <option value="private">{t('pay.privateExpense')}</option>
          <option value="company-card">{t('pay.companyCard')}</option>
        </Select></Field>
      <Field label={t('pay.amount')}><Currency value={draft.amount} onChange={(event) => set({ amount: event.target.value })} placeholder="0" /></Field>
      <Field label={t('pay.currency')}><Select value={draft.currency} onChange={(event) => set({ currency: event.target.value })}>{ANSATT_CURRENCIES.map(([code]) => <option key={code} value={code}>{code} - {t('emp.currency.' + code)}</option>)}</Select></Field>
      <ForeignAmountNokField currency={draft.currency} amount={draft.amount} value={draft.amountNok} onChange={(amountNok) => set({ amountNok })} />
    </div>
    {projects.length > 0 && <Field label={t('pay.expenseProject', 'Prosjekt')} style={{ marginTop: 14 }} hint={t('pay.expenseProjectHint', 'Utlegg på et prosjekt kan viderefaktureres kunden.')}>
      <Select value={draft.projectId} onChange={(event) => set({ projectId: event.target.value })}>
        <option value="">{t('pay.expenseNoProject', 'Ikke på prosjekt')}</option>
        {projects.map((project) => <option key={project.id} value={project.id}>{project.name}</option>)}
      </Select></Field>}
    <Field label={t('pay.description')} style={{ marginTop: 14 }}><Input value={draft.description} onChange={(event) => set({ description: event.target.value })} placeholder={t('pay.whatIsExpenseFor')} /></Field>
    <AnsattAttachmentPicker file={draft.file} onFile={(file) => set({ file })} style={{ marginTop: 14 }} />
    </div>
  </Modal>;
}

function AnsattTravelCreateForm({ portal, onClose, onCreate }) {
  const [draft, setDraft] = React.useState(() => (window.tripFormDefaults ? window.tripFormDefaults({
    employee: portal.employee?.name || '',
    date: ansattToday(),
    dateFrom: ansattToday(),
    dateTo: ansattToday(),
  }) : {
    diet: 'no',
    overnight: 'no',
    date: ansattToday(),
    dateFrom: ansattToday(),
    dateTo: ansattToday(),
    country: 'Norge',
    purpose: '',
    meals: {},
  }));
  const set = (key, value) => setDraft((current) => ({ ...current, [key]: value }));
  const create = () => {
    if (window.tripFormValid ? !window.tripFormValid(draft) : !draft.purpose?.trim()) {
      toast(t('emp.travelFillIn'), 'warning');
      return;
    }
    const dates = window.tripDates ? window.tripDates(draft) : { dateFrom: draft.dateFrom || draft.date, dateTo: draft.dateTo || draft.dateFrom || draft.date };
    onCreate({
      id: '',
      businessId: portal.businessId,
      employeeId: portal.employee.id,
      employeeName: portal.employee.name,
      dateFrom: dates.dateFrom,
      dateTo: dates.dateTo || dates.dateFrom,
      destination: draft.country || 'Norge',
      purpose: draft.purpose.trim(),
      travelType: draft.diet === 'yes' ? 'diet' : 'mixed',
      hasDiet: draft.diet === 'yes',
      overnight: draft.overnight === 'yes',
      timeFrom: draft.timeFrom || '',
      timeTo: draft.timeTo || '',
      coveredMeals: draft.meals || {},
      status: 'draft',
      mileageLines: [],
      expenseLines: [],
      accommodationLines: [],
    });
  };
  return <Modal open onClose={onClose} title={t('pay.registerTravel')} max={620} titleRight={<span className="t-sm muted" style={{ fontWeight: 700 }}>{t('pay.sentForApproval')}</span>} footer={<React.Fragment><Button variant="ghost" onClick={onClose}>{t('pay.cancel')}</Button><Button icon="arrowRight" onClick={create}>{t('pay.createTravelClaim')}</Button></React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      {window.TravelTripFields
        ? <window.TravelTripFields v={draft} set={set} ns="ansatt-trip" />
        : <React.Fragment>
          <div className="grid-2 gap-14">
            <Field label={t('pay.dateFrom')}><Input type="date" value={draft.dateFrom} onChange={(event) => set('dateFrom', event.target.value)} /></Field>
            <Field label={t('pay.dateTo')}><Input type="date" value={draft.dateTo} onChange={(event) => set('dateTo', event.target.value)} /></Field>
          </div>
          <Field label={t('pay.purposeHelp')} help={t('helpTopics.tripPurpose.body')} helpTitle={t('helpTopics.tripPurpose.title')}><textarea className="input" rows={3} value={draft.purpose} onChange={(event) => set('purpose', event.target.value)} placeholder={t('pay.purposePh')} /></Field>
          <Field label={t('pay.whereDidYouGo')} help={t('helpTopics.tripPurpose.body')} helpTitle={t('helpTopics.tripPurpose.title')}><Input value={draft.country} onChange={(event) => set('country', event.target.value)} placeholder={t('pay.norway')} /></Field>
        </React.Fragment>}
    </div>
  </Modal>;
}

function AnsattTravelLineForm({ kind, portal, onClose, onSave, line }) {
  const [draft, setDraft] = React.useState({
    category: ANSATT_EXPENSE_CATEGORIES[0],
    date: ansattToday(),
    description: '',
    paymentMethod: 'private',
    amount: '',
    currency: 'NOK', amountNok: '',
    file: null,
    fromLocation: '',
    toLocation: '',
    kilometers: '',
    returnTrip: false,
    tollAmount: '',
    lodgingType: 'Hotell',
    location: '',
    dateFrom: ansattToday(),
    dateTo: ansattToday(),
    ...(line ? {
      category: line.category || ANSATT_EXPENSE_CATEGORIES[0],
      date: line.date || ansattToday(),
      description: line.description || '',
      paymentMethod: line.paymentMethod || line.tollPaymentMethod || 'private',
      amount: (line.amountNet ?? line.amount) == null ? '' : String(line.amountNet ?? line.amount),
      currency: line.currency || 'NOK', amountNok: line.amountNok == null ? '' : String(line.amountNok),
      fromLocation: line.fromLocation || '',
      toLocation: line.toLocation || '',
      kilometers: line.kilometers == null ? '' : String(line.kilometers),
      returnTrip: false,
      tollAmount: Number(line.tollAmount) > 0 ? String(line.tollAmount) : '',
      lodgingType: line.lodgingType || line.type || 'Hotell',
      location: line.location || '',
      dateFrom: line.dateFrom || ansattToday(),
      dateTo: line.dateTo || line.dateFrom || ansattToday(),
    } : {}),
  });
  const [busy, setBusy] = React.useState(false);
  const set = (patch) => setDraft((current) => ({ ...current, ...patch }));
  const number = (value) => Number(String(value || '').replace(',', '.')) || 0;
  const save = async () => {
    if (kind === 'expense') {
      const amount = number(draft.amount);
      const existingAttachment = line?.attachment || line?.attachments?.[0] || null;
      if (!draft.description.trim() || amount <= 0 || (!draft.file && !existingAttachment)) {
        toast(t('emp.lineExpenseRequired'), 'warning');
        return;
      }
      setBusy(true);
      try {
        const attachment = draft.file
          ? await window.PlummeBackend.uploadEmployeePortalAttachment({ businessId: portal.businessId, employeeId: portal.employee.id, file: draft.file })
          : existingAttachment;
        onSave({
          id: line?.id || ansattId('expense-line'),
          category: draft.category,
          date: draft.date,
          description: draft.description.trim(),
          paymentMethod: draft.paymentMethod,
          amount,
          amountNet: amount,
          currency: draft.currency, amountNok: number(draft.amountNok) || undefined,
          vatRate: 0,
          vatTreatment: 'zeroRated',
          attachment,
          attachmentId: attachment.id,
          attachmentName: attachment.name,
          attachmentMimeType: attachment.mimeType,
          attachmentStoragePath: attachment.storagePath,
          attachmentDownloadUrl: attachment.downloadUrl,
          attachments: [attachment],
        });
      } catch (error) {
        toast(error?.message || t('emp.attachmentUploadFailed'), 'error');
      } finally {
        setBusy(false);
      }
      return;
    }
    if (kind === 'mileage') {
      const km = number(draft.kilometers);
      if (!draft.fromLocation.trim() || !draft.toLocation.trim() || km <= 0) {
        toast(t('emp.mileageFillIn'), 'warning');
        return;
      }
      const totalKm = km * (draft.returnTrip ? 2 : 1); const tollAmount = number(draft.tollAmount);
      onSave({
        id: line?.id || ansattId('mileage-line'),
        date: draft.date,
        fromLocation: draft.fromLocation.trim(),
        toLocation: draft.toLocation.trim(),
        kilometers: totalKm,
        returnTrip: draft.returnTrip,
        vehicle: 'Egen bil',
        ratePerKm: ANSATT_TRAVEL_RATE,
        tollAmount,
        tollPaymentMethod: draft.paymentMethod,
        mileageAmount: Math.round(totalKm * ANSATT_TRAVEL_RATE),
        payrollAmount: Math.round(totalKm * ANSATT_TRAVEL_RATE) + (draft.paymentMethod === 'private' ? tollAmount : 0),
      });
      return;
    }
    if (!draft.location.trim()) {
      toast(t('emp.accommodationFillIn'), 'warning');
      return;
    }
    onSave({
      id: line?.id || ansattId('accommodation-line'),
      dateFrom: draft.dateFrom,
      dateTo: draft.dateTo || draft.dateFrom,
      lodgingType: draft.lodgingType,
      location: draft.location.trim(),
      description: draft.location.trim(),
      amount: number(draft.amount),
      paymentMethod: draft.paymentMethod,
    });
  };
  if (kind === 'mileage' && window.BackendMileageDialog) {
    return <window.BackendMileageDialog line={line} onClose={onClose} onSave={(saved) => onSave({
      ...saved,
      id: saved.id || line?.id || ansattId('mileage-line'),
    })} />;
  }
  if (kind === 'accommodation' && window.BackendAccommodationDialog) {
    return <window.BackendAccommodationDialog line={line} onClose={onClose} onSave={(saved) => onSave({
      ...saved,
      id: saved.id || line?.id || ansattId('accommodation-line'),
    })} />;
  }
  const editing = Boolean(line); const title = kind === 'mileage'
    ? (editing ? t('emp.editMileage') : t('emp.newMileage'))
    : kind === 'accommodation'
      ? (editing ? t('emp.editAccommodation') : t('emp.newAccommodation'))
      : (editing ? t('emp.editExpense') : t('emp.newExpense'));
  return <PayDialog open onClose={onClose} title={title} max={620} saveLabel={busy ? t('emp.saving') : editing ? t('emp.save') : t('emp.add')} onSave={save}>
    {kind === 'expense' && <div className="col gap-14">
      <div className="grid-2 gap-14">
        <Field label={t('pay.category')}><Select value={draft.category} onChange={(event) => set({ category: event.target.value })}>{ANSATT_EXPENSE_CATEGORIES.map((category) => <option key={category}>{category}</option>)}</Select></Field>
        <Field label={t('pay.date')}><Input type="date" value={draft.date} onChange={(event) => set({ date: event.target.value })} /></Field>
        <Field label={t('pay.paidWith')} help={t('helpTopics.privatePayment.body')} helpTitle={t('helpTopics.privatePayment.title')}><Select value={draft.paymentMethod} onChange={(event) => set({ paymentMethod: event.target.value })}><option value="private">{t('pay.privateExpense')}</option><option value="company-card">{t('pay.companyCard')}</option></Select></Field>
        <Field label={t('pay.amount')}><Currency value={draft.amount} onChange={(event) => set({ amount: event.target.value })} placeholder="0" /></Field>
        <Field label={t('pay.currency')}><Select value={draft.currency} onChange={(event) => set({ currency: event.target.value })}>{ANSATT_CURRENCIES.map(([code]) => <option key={code} value={code}>{code} - {t('emp.currency.' + code)}</option>)}</Select></Field><ForeignAmountNokField currency={draft.currency} amount={draft.amount} value={draft.amountNok} onChange={(amountNok) => set({ amountNok })} />
      </div>
      <Field label={t('pay.description')}><Input value={draft.description} onChange={(event) => set({ description: event.target.value })} placeholder={t('pay.whatIsExpenseFor')} /></Field>
      <AnsattAttachmentPicker file={draft.file} onFile={(file) => set({ file })} />
    </div>}
    {kind === 'mileage' && <div className="col gap-14">
      <Field label={t('pay.date')}><Input type="date" value={draft.date} onChange={(event) => set({ date: event.target.value })} /></Field>
      <div className="grid-2 gap-14">
        <Field label={t('pay.from')}><Input value={draft.fromLocation} onChange={(event) => set({ fromLocation: event.target.value })} /></Field>
        <Field label={t('pay.to')}><Input value={draft.toLocation} onChange={(event) => set({ toLocation: event.target.value })} /></Field>
        <Field label={t('pay.kilometres')}><Input inputMode="decimal" value={draft.kilometers} onChange={(event) => set({ kilometers: event.target.value })} /></Field>
        <Field label={t('pay.tolls')}><Currency value={draft.tollAmount} onChange={(event) => set({ tollAmount: event.target.value })} placeholder="0" /></Field>
      </div>
      <label className="row gap-8" style={{ fontWeight: 700 }}><input type="checkbox" checked={draft.returnTrip} onChange={(event) => set({ returnTrip: event.target.checked })} /> {t('sharedText.km.returnTrip')}</label>
      <Field label={t('pay.tollsPaidWith')}><Select value={draft.paymentMethod} onChange={(event) => set({ paymentMethod: event.target.value })}><option value="private">{t('pay.privateExpense')}</option><option value="company-card">{t('pay.companyCard')}</option></Select></Field>
    </div>}
    {kind === 'accommodation' && <div className="col gap-14">
      <div className="grid-2 gap-14">
        <Field label={t('pay.fromDate')}><Input type="date" value={draft.dateFrom} onChange={(event) => set({ dateFrom: event.target.value })} /></Field>
        <Field label={t('pay.toDate')}><Input type="date" value={draft.dateTo} onChange={(event) => set({ dateTo: event.target.value })} /></Field>
        <Field label={t('pay.type')} help={t('helpTopics.payType.body')} helpTitle={t('helpTopics.payType.title')}><Select value={draft.lodgingType} onChange={(event) => set({ lodgingType: event.target.value })}><option>{t('pay.hotel')}</option><option>{t('pay.otherAccommodation')}</option><option>{t('pay.guesthouse')}</option></Select></Field>
        <Field label={t('pay.amount')}><Currency value={draft.amount} onChange={(event) => set({ amount: event.target.value })} placeholder="0" /></Field>
      </div>
      <Field label={t('pay.place')}><Input value={draft.location} onChange={(event) => set({ location: event.target.value })} placeholder={t('pay.hotelOrPlace')} /></Field>
    </div>}
  </PayDialog>;
}

function AnsattTravelDetailModal({ travel, portal, onClose, onSaved, onUpdate }) {
  const [sub, setSub] = React.useState('');
  const [editing, setEditing] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const status = travel.status || 'draft';
  const readOnly = !ansattCanEdit(status);
  const canWithdraw = ansattCanWithdraw(status);
  const changeLog = Array.isArray(travel.changeLog) ? travel.changeLog : [];
  const travelPayload = (action) => ({
    action,
    businessId: portal.businessId,
    employeeId: portal.employee.id,
    travelId: travel.id || '',
    dateFrom: travel.dateFrom,
    dateTo: travel.dateTo || travel.dateFrom,
    destination: travel.destination,
    purpose: travel.purpose,
    travelType: travel.travelType || 'mixed',
    hasDiet: travel.hasDiet === true,
    overnight: travel.overnight === true,
    timeFrom: travel.timeFrom || '',
    timeTo: travel.timeTo || '',
    coveredMeals: travel.coveredMeals || null,
    mileageLines: travel.mileageLines || [],
    expenseLines: travel.expenseLines || [],
    accommodationLines: travel.accommodationLines || [],
    note: travel.note || '',
  });
  const upsertLine = (kind, line) => {
    const key = kind === 'mileage' ? 'mileageLines' : kind === 'accommodation' ? 'accommodationLines' : 'expenseLines';
    onUpdate((current) => {
      const base = current || travel;
      const rows = base[key] || [];
      const exists = rows.some((row) => row.id === line.id);
      return { ...base, [key]: exists ? rows.map((row) => (row.id === line.id ? { ...row, ...line } : row)) : [line, ...rows] };
    });
    setSub('');
    setEditing(null);
  };
  const saveDraft = async (showToast = true) => {
    if (readOnly) {
      onClose();
      return;
    }
    setBusy(true);
    try {
      await window.PlummeBackend.mutateEmployeePortalTravel(travelPayload('save'));
      if (showToast) toast(t('emp.draftSaved'), 'success');
      onSaved();
    } catch (error) {
      toast(error?.message || t('emp.draftSaveFailed'), 'error');
    } finally {
      setBusy(false);
    }
  };
  const submit = async () => {
    setBusy(true);
    try {
      await window.PlummeBackend.mutateEmployeePortalTravel(travelPayload('submit'));
      toast(status === 'rejected' ? t('emp.travelResubmitted') : t('emp.travelSentForApproval'), 'success');
      onSaved();
    } catch (error) {
      toast(error?.message || t('emp.travelSendFailed'), 'error');
    } finally {
      setBusy(false);
    }
  };
  const withdraw = async () => {
    if (!canWithdraw) return;
    if (!window.confirm(t('emp.confirmWithdraw'))) return;
    setBusy(true);
    try {
      await window.PlummeBackend.mutateEmployeePortalTravel({ ...travelPayload('withdraw'), travelId: travel.id });
      toast(t('emp.travelWithdrawn'), 'success');
      onSaved();
    } catch (error) {
      toast(error?.message || t('emp.withdrawFailed'), 'error');
    } finally {
      setBusy(false);
    }
  };
  const deleteTravel = async () => {
    if (!ansattCanDelete(status) || !travel.id) return;
    const isExpense = travel.portalSubmissionType === 'expense';
    if (!window.confirm(t(isExpense ? 'emp.confirmDeleteExpenseOfTravel' : 'emp.confirmDeleteTravel'))) return;
    setBusy(true);
    try {
      await window.PlummeBackend.mutateEmployeePortalTravel({ ...travelPayload('delete'), travelId: travel.id });
      toast(isExpense ? t('emp.expenseDeleted') : t('emp.travelDeleted'), 'success');
      onSaved();
    } catch (error) {
      toast(error?.message || t('emp.deleteFailed'), 'error');
    } finally {
      setBusy(false);
    }
  };
  const lineCount = (travel.mileageLines || []).length + (travel.expenseLines || []).length + (travel.accommodationLines || []).length;
  const editLineButton = (kind, line) => (readOnly ? null : <button
    type="button"
    className="icon-btn sm ghost ans-line-edit"
    title={t('emp.editLine')}
    aria-label={t('emp.editLine')}
    onClick={(event) => { event.stopPropagation(); setEditing({ kind, line }); }}
  ><Icon name="pencil" size={15} /></button>);
  return <Modal open onClose={() => saveDraft(false)} title={t('pay.travelClaim')} max={760} titleRight={<AnsattPortalStatusPill status={travel.displayStatus || status}/>} footer={<React.Fragment>{ansattCanDelete(status) && travel.id && <Button variant="danger" icon="trash" disabled={busy} onClick={deleteTravel}>{t('pay.delete')}</Button>}{canWithdraw && <Button variant="secondary" icon="refresh" disabled={busy} onClick={withdraw}>{busy ? t('emp.withdrawing') : t('emp.withdraw')}</Button>}<Button variant="ghost" disabled={busy} onClick={() => saveDraft(true)}>{readOnly ? t('emp.close') : busy ? t('emp.saving') : t('emp.saveDraft')}</Button>{!readOnly && <Button icon="send" disabled={busy} onClick={submit}>{busy ? t('emp.sending') : status === 'rejected' ? t('emp.resubmit') : t('emp.submitTravel')}</Button>}</React.Fragment>}>
    <div className="col gap-14">
      {status === 'rejected' && <div className="ans-trip-note ans-trip-note-error">
        <b>{t('pay.rejectedByEmployer')}</b>
        {travel.rejectionNote && <span>{travel.rejectionNote}</span>}
        <span>{t('emp.fixAndResubmit')}</span>
      </div>}
      {ansattEditedAfterSubmit(travel) && <div className="ans-trip-note">
        <b>{t('emp.changedAfterSubmit')}</b>
        <span>{t('emp.changedAfterSubmitText')}</span>
      </div>}
      {!readOnly && <div className="row gap-10" style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
        <Button variant="secondary" size="sm" onClick={() => setSub('accommodation')} data-help={t('helpTopics.subsistence.body')} data-help-title={t('helpTopics.subsistence.title')}>{t('pay.newAccommodation')}</Button>
        <Button variant="secondary" size="sm" onClick={() => setSub('mileage')}>{t('pay.newTrip')}</Button>
        <Button variant="secondary" size="sm" onClick={() => setSub('expense')}>{t('pay.newExpense')}</Button>
      </div>}
      <div className="ans-trip-card">
        {lineCount ? <div className="col gap-10">
          {(travel.mileageLines || []).map((line) => <div key={line.id} className="ans-list-row"><Icon name="car" size={18} /><span className="grow">{line.fromLocation} - {line.toLocation}</span><b>{line.kilometers}{line.workflowVersion===2&&line.returnTrip?' × 2':''} km</b>{editLineButton('mileage', line)}</div>)}
          {(travel.expenseLines || []).map((line) => <div key={line.id} className="ans-list-row"><Icon name="receipt" size={18} /><span className="grow">{line.description}</span><b>{ansattAmount(line.amountNet || line.amount, line.currency)}</b>{editLineButton('expense', line)}</div>)}
          {(travel.accommodationLines || []).map((line) => <div key={line.id} className="ans-list-row"><Icon name="building" size={18} /><span className="grow">{line.lodgingType} {line.location || line.description || ''}</span><b>{ansattMoney(line.amount)}</b>{editLineButton('accommodation', line)}</div>)}
        </div> : <EmptyState noVisual title={t('pay.noLinesYet')} text={t('emp.addLinesToStart')} />}
      </div>
      <div className="ans-trip-card">
        <div className="ans-trip-dl">
          <div className="ans-trip-dl-row"><span>{t('pay.employee')}</span><b>{portal.employee.name}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.subsistence')}</span><b>{travel.hasDiet ? t('emp.dietCalculated') : t('emp.noDiet')}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.from')}</span><b>{ansattDate(travel.dateFrom)}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.to')}</span><b>{ansattDate(travel.dateTo || travel.dateFrom)}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.description')}</span><b>{travel.purpose}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.country')}</span><b>{travel.destination}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.status')}</span><span className={`ans-exp-pill ans-exp-${ansattStatusClass(status)}`}>{ansattStatus(status)[1]}</span></div>
        </div>
      </div>
      <div className="ans-trip-card">
        <b className="t-h3" style={{ fontSize: 15 }}>{t('pay.payroll')}</b>
        <p className="t-sm muted" style={{ fontWeight: 600, margin: '6px 0 8px' }}>{ansattTravelPayout(travel) > 0 ? (travel.displayStatus==='paid'?t('pay.paidOut'):travel.displayStatus==='included-in-payroll'?t('km.portal.inPayroll'):t('km.portal.pendingPayroll')) : t('emp.noPayrollPayout')}</p>
        <b className="t-num" style={{ fontSize: 17 }}>{ansattMoney(ansattTravelPayout(travel))}</b>
      </div>
    </div>
    {changeLog.length > 0 && <div className="ans-trip-card mt-16">
      <b className="t-h3" style={{ fontSize: 15 }}>{t('emp.history')}</b>
      <div className="col gap-8" style={{ marginTop: 8 }}>
        {[...changeLog].reverse().map((entry, index) => <div key={`${entry.at}-${index}`} className="row between gap-12 t-sm" style={{ fontWeight: 600 }}>
          <span>{ansattChangeText(entry)}{entry.note ? ` — ${entry.note}` : ''}</span>
          <span className="muted" style={{ flex: 'none' }}>{ansattChangeStamp(entry.at)}</span>
        </div>)}
      </div>
    </div>}
    {sub && <AnsattTravelLineForm kind={sub} portal={portal} onClose={() => setSub('')} onSave={(line) => upsertLine(sub, line)} />}
    {editing && <AnsattTravelLineForm
      kind={editing.kind}
      line={editing.line}
      portal={portal}
      onClose={() => setEditing(null)}
      onSave={(line) => upsertLine(editing.kind, line)}
    />}
  </Modal>;
}

function AnsattPayslipPreviewModal({ run, onClose }) {
  const downloadUrl = run.payslipDownloadUrl || run.payslipUrl || run.downloadUrl || '';
  const gross = Number(run.grossSalary || run.grossPay || 0);
  const tax = Number(run.taxDeduction || 0);
  const reimbursement = Number(run.expenseReimbursement || 0);
  const net = Number(run.netPay || Math.max(0, gross - tax + reimbursement));
  const isPaid = run.paymentStatus === 'paid' || Boolean(run.paidAt);
  return <Modal open onClose={onClose} title={t('pay.payslip')} max={760} titleRight={<AnsattPortalStatusPill status={isPaid ? 'paid' : run.status} />} footer={<React.Fragment>{downloadUrl && <Button variant="secondary" icon="download" onClick={() => { const a = document.createElement('a'); a.href = downloadUrl; a.download = `lonnsslipp-${run.period || run.id || 'plumme'}.pdf`; document.body.appendChild(a); a.click(); a.remove(); }}>{t('pay.download')}</Button>}<Button onClick={onClose}>{t('pay.close')}</Button></React.Fragment>}>
    <div className="ans-slip">
      <div className="ans-slip-top">
        <div style={{ minWidth: 0 }}><div className="ans-slip-doc">{t('pay.payslip')}</div><div className="ans-slip-co">{run.period || t('emp.payrollRunFallback')}</div><div className="t-sm muted" style={{ fontWeight: 600 }}>{isPaid ? t('sharedText.pay.paidOut') : t('pay.toPayOut')} {ansattDate(isPaid ? run.paidAt : run.paymentDate)}</div></div>
        <div className="ans-slip-net"><span className="t-xs muted" style={{ fontWeight: 700 }}>{isPaid ? t('pay.netPaid') : t('pay.toPayOut')}</span><b className="t-num">{ansattMoney(net)}</b></div>
      </div>
      <div className="ans-slip-meta">
        <div><span>{t('pay.period')}</span><b>{run.period || '-'}</b></div>
        <div><span>{isPaid ? t('sharedText.pay.paidOut') : t('pay.toPayOut')}</span><b>{ansattDate(isPaid ? run.paidAt : run.paymentDate)}</b></div>
        <div><span>{t('pay.status')}</span><b>{ansattStatus(isPaid ? 'paid' : run.status)[1]}</b></div>
      </div>
      <div className="ans-slip-sec">{t('pay.payAndDeductions')}</div>
      <div className="ans-slip-row"><div className="ans-slip-label">{t('pay.grossPay')}</div><div className="t-num ans-slip-val">{ansattMoney(gross)}</div></div>
      <div className="ans-slip-row"><div className="ans-slip-label">{t('pay.withholdingTax')}</div><div className="t-num ans-slip-val neg">{tax > 0 ? '-' : ''}{ansattMoney(tax)}</div></div>
      {reimbursement > 0 && <div className="ans-slip-row"><div className="ans-slip-label">{t('pay.expenseRefund')}</div><div className="t-num ans-slip-val">{ansattMoney(reimbursement)}</div></div>}
      <div className="ans-slip-row"><div className="ans-slip-label">{isPaid ? t('pay.netPaid') : t('pay.toPayOut')}</div><div className="t-num ans-slip-val sum">{ansattMoney(net)}</div></div>
      {!downloadUrl && <div className="t-sm muted" style={{ fontWeight: 700, padding: '16px 40px 22px' }}>{t('pay.payslipPdfNote')}</div>}
    </div>
  </Modal>;
}

function AnsattPayslipsModal({ rows, onClose }) {
  const [preview, setPreview] = React.useState(null);
  return <Modal open onClose={onClose} title={t('pay.payslips')} max={620} titleRight={<span className="t-sm muted" style={{ fontWeight: 700 }}>{t('emp.totalCount', { count: rows.length })}</span>} footer={<Button onClick={onClose}>{t('pay.close')}</Button>}>
    {rows.length ? <div className="col gap-10">{rows.map((run) => <div data-app-control="true" key={run.id} className="ans-list-row" onClick={() => setPreview(run)}>
      <span className="icon-chip" style={{ background: 'var(--panel)', flex: 'none' }}><Icon name="fileText" size={18} /></span>
      <div className="grow" style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 14 }}>{run.period || t('emp.payrollRunFallback')}</div><div className="t-sm muted" style={{ fontWeight: 600 }}>{t('sharedText.inv.col.net')} {ansattMoney(run.netPay)} · {run.paymentStatus === 'paid' || run.paidAt ? `${t('sharedText.pay.paidOut')} ${ansattDate(run.paidAt || run.paymentDate)}` : `${t('pay.toPayOut')} ${ansattDate(run.paymentDate)}`}</div></div>
      <AnsattPortalStatusPill status={run.paymentStatus === 'paid' || run.paidAt ? 'paid' : run.status} />
      <Icon name="chevRight" size={18} className="muted" />
    </div>)}</div> : <div className="t-sm muted" style={{ fontWeight: 600 }}>{t('pay.noPayslipsYet')}</div>}
    {preview && <AnsattPayslipPreviewModal run={preview} onClose={() => setPreview(null)} />}
  </Modal>;
}

function AnsattExpensesModal({ rows, portal, onClose, onDeleted }) {
  const [filter, setFilter] = React.useState('alle');
  const [selectedExpense, setSelectedExpense] = React.useState(null);
  const shown = rows.filter((entry) => filter === 'alle' || ansattStatusClass(entry.displayStatus || entry.approvalStatus || entry.status) === filter);
  const filters = [['alle',t('km.portal.all')],['warn',t('km.portal.sent')],['ok',t('km.portal.approved')],['payroll',t('km.portal.inPayroll')],['paid',t('pay.paidOut')],['err',t('km.portal.rejected')],['muted',t('km.portal.draft')]];
  return <Modal open onClose={onClose} title={t('pay.myExpenses')} max={680} titleRight={<span className="t-sm muted" style={{ fontWeight: 700 }}>{t('emp.totalCount', { count: rows.length })}</span>} footer={<Button onClick={onClose}>{t('pay.close')}</Button>}>
    <div className="ans-exp-filters">{filters.map(([key, label]) => <button key={key} className={`bank-chip${filter === key ? ' on' : ''}`} onClick={() => setFilter(key)}>{label}<span className="bank-chip-n">{key === 'alle' ? rows.length : rows.filter((entry) => ansattStatusClass(entry.displayStatus || entry.approvalStatus || entry.status) === key).length}</span></button>)}</div>
    {shown.length ? <div className="col gap-10">{shown.map((expense) => <div data-app-control="true" key={expense.id} className="ans-list-row" onClick={() => setSelectedExpense(expense)}>
      <span className="icon-chip" style={{ background: 'var(--panel)', flex: 'none' }}><Icon name="receipt" size={18} /></span>
      <div className="grow" style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 14 }}>{expense.category || t('emp.expenseFallback')}</div><div className="t-sm muted" style={{ fontWeight: 600 }}>{ansattDate(expense.date)} - {expense.description}{expense.attachmentName ? ' - ' + t('emp.attachmentFallback') : ''}</div></div>
      <span className="t-num" style={{ fontWeight: 800, flex: 'none' }}>{ansattAmount(expense.amountNet, expense.currency)}</span>
      <AnsattPortalStatusPill status={expense.displayStatus || expense.approvalStatus || expense.status} />
      <Icon name="chevRight" size={18} className="muted" />
    </div>)}</div> : <div className="t-sm muted" style={{ fontWeight: 600 }}>{t('pay.noExpensesInView')}</div>}
    {selectedExpense && <AnsattExpenseDetailModal expense={selectedExpense} portal={portal} onClose={() => setSelectedExpense(null)} onDeleted={onDeleted} />}
  </Modal>;
}

function AnsattExpenseDetailModal({ expense, portal, onClose, onDeleted }) {
  const [preview, setPreview] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const status = expense.displayStatus || expense.approvalStatus || expense.status;
  const rejectionNote = String(expense.rejectionNote || '').trim();
  const attachmentName = expense.attachmentName || expense.attachments?.[0]?.name || '';
  const attachmentUrl = expense.attachmentDownloadUrl || expense.downloadUrl || expense.attachments?.[0]?.downloadUrl || '';
  const attachmentStoragePath = expense.attachmentStoragePath || expense.storagePath || expense.attachments?.[0]?.storagePath || '';
  const attachmentMimeType = expense.attachmentMimeType || expense.mimeType || expense.attachments?.[0]?.mimeType || '';
  const openPreview = async () => {
    let src = attachmentUrl;
    if (!src && attachmentStoragePath && window.PlummeBackend?.getEmployeePortalAttachmentDownloadUrl) {
      try {
        src = await window.PlummeBackend.getEmployeePortalAttachmentDownloadUrl(attachmentStoragePath);
      } catch (error) {
        toast(error?.message || t('emp.voucherFetchFailed'), 'error');
        return;
      }
    }
    if (!src) {
      toast(t('emp.noPreviewLink'), 'warning');
      return;
    }
    setPreview({ src, name: attachmentName || t('emp.attachmentFallback'), mimeType: attachmentMimeType });
  };
  const canDelete = ansattCanDelete(status) && Boolean(expense.travelId);
  const deleteExpense = async () => {
    if (!canDelete) return;
    if (!window.confirm(t('emp.confirmDeleteExpense'))) return;
    setBusy(true);
    try {
      await window.PlummeBackend.mutateEmployeePortalTravel({
        action: 'delete',
        businessId: expense.businessId || portal?.businessId,
        employeeId: expense.employeeId || portal?.employee?.id,
        travelId: expense.travelId,
      });
      toast(t('emp.expenseDeleted'), 'success');
      onClose();
      onDeleted && onDeleted();
    } catch (error) {
      toast(error?.message || t('emp.expenseDeleteFailed'), 'error');
    } finally {
      setBusy(false);
    }
  };
  return <Modal open onClose={onClose} title={t('pay.expenses')} max={560} titleRight={<AnsattPortalStatusPill status={status} />} footer={<React.Fragment>{canDelete && <Button variant="danger" icon="trash" disabled={busy} onClick={deleteExpense}>{busy ? t('emp.deleting') : t('emp.delete')}</Button>}<Button onClick={onClose}>{t('pay.close')}</Button></React.Fragment>}>
    <div className="col gap-14">
      {ansattStatusClass(status) === 'err' && rejectionNote && <div className="ans-trip-note ans-trip-note-error">
        <b>{t('pay.rejectedByEmployer')}</b>
        <span>{rejectionNote}</span>
      </div>}
      <div className="ans-trip-card">
        <div className="ans-trip-dl">
          <div className="ans-trip-dl-row"><span>{t('pay.category')}</span><b>{expense.category || t('emp.expenseFallback')}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.date')}</span><b>{ansattDate(expense.date)}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.description')}</span><b>{expense.description || '-'}</b></div>
          <div className="ans-trip-dl-row"><span data-help={t('helpTopics.privatePayment.body')} data-help-title={t('helpTopics.privatePayment.title')}>{t('pay.paidWith')}</span><b>{expense.paymentMethod === 'company-card' ? t('pay.companyCard') : t('pay.privateExpense')}</b></div>
          <div className="ans-trip-dl-row"><span>{t('pay.amount')}</span><b>{ansattAmount(expense.amountNet, expense.currency)}</b></div>
        </div>
      </div>
      <button type="button" className={'ans-exp-bilag ans-exp-bilag-open' + (attachmentName || attachmentUrl || attachmentStoragePath ? '' : ' disabled')} onClick={openPreview} disabled={!attachmentName && !attachmentUrl && !attachmentStoragePath}>
        <Icon name="fileText" size={18} />
        <div className="grow" style={{ minWidth: 0 }}>
          <div className="t-h3" style={{ fontSize: 14 }}>{attachmentName || t('emp.noAttachmentFound')}</div>
          <div className="t-sm muted" style={{ fontWeight: 600 }}>{attachmentName ? t('emp.tapToPreview') : t('emp.noAttachmentName')}</div>
        </div>
        {(attachmentUrl || attachmentStoragePath) && <span className="ans-exp-bilag-cta">{t('pay.preview')}<Icon name="chevRight" size={16} /></span>}
      </button>
    </div>
    {preview && <AnsattAttachmentBlobPreviewModal preview={preview} onClose={() => setPreview(null)} />}
  </Modal>;
}

function AnsattAttachmentBlobPreviewModal({ preview, onClose }) {
  const name = preview?.name || t('emp.attachmentFallback');
  const src = preview?.src || '';
  const mime = String(preview?.mimeType || '').toLowerCase();
  const externalUrl = /^https?:\/\//i.test(String(src)) && (() => {
    try { return new URL(src).origin !== window.location.origin; } catch (error) { return false; }
  })();
  const [renderSrc, setRenderSrc] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  React.useEffect(() => {
    let cancelled = false;
    let objectUrl = '';
    setLoading(true);
    setError('');
    setRenderSrc('');
    (async () => {
      try {
        if (!src) throw new Error('missing attachment source');
        if (externalUrl) {
          setRenderSrc(src);
          return;
        }
        const response = await fetch(src, { mode: 'cors' });
        if (!response.ok) throw new Error('attachment fetch failed');
        const blob = await response.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setRenderSrc(objectUrl);
      } catch (err) {
        if (!cancelled) setError(t('emp.previewFetchFailed'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, externalUrl]);
  const isPdf = mime.includes('pdf') || /\.pdf($|\?)/i.test(src) || /\.pdf$/i.test(name);
  const isImage = mime.startsWith('image/') || /\.(png|jpe?g|webp|gif|bmp)($|\?)/i.test(src) || /\.(png|jpe?g|webp|gif|bmp)$/i.test(name);
  const displaySrc = renderSrc || (!isPdf && isImage ? src : '');
  return <Modal open onClose={onClose} title={name} max={980} titleRight={src ? <Button size="sm" variant="secondary" icon="download" onClick={() => { const a = document.createElement('a'); a.href = src; a.download = name; document.body.appendChild(a); a.click(); a.remove(); }}>{t('pay.download')}</Button> : null} footer={<Button onClick={onClose}>{t('pay.close')}</Button>}>
    {loading ? <div className="pdfv-msg"><Icon name="fileText" size={28} /><b>{t('pay.loadingReceipt')}</b></div>
      : error ? <div className="pdfv-msg"><Icon name="fileText" size={28} /><b style={{ color: 'var(--error)' }}>{error}</b><span className="muted" style={{ fontWeight: 600 }}>{t('pay.canStillDownload')}</span></div>
      : isPdf && externalUrl && displaySrc
        ? <div className="ans-attachment-frame"><iframe src={displaySrc} title={name} /></div>
      : isPdf && typeof PdfViewer === 'function' && displaySrc
        ? <PdfViewer src={displaySrc} name={name} />
        : isImage && displaySrc
          ? <div className="ans-attachment-preview"><img src={displaySrc} alt={name} /></div>
          : <div className="pdfv-msg"><Icon name="fileText" size={28} /><b>{name}</b><span className="muted" style={{ fontWeight: 600 }}>{t('pay.cannotPreview')}</span></div>}
  </Modal>;
}

function AnsattAttachmentPreviewModal({ preview, onClose }) {
  const name = preview?.name || t('emp.attachmentFallback');
  const src = preview?.src || '';
  const mime = String(preview?.mimeType || '').toLowerCase();
  const isPdf = mime.includes('pdf') || /\.pdf($|\?)/i.test(src) || /\.pdf$/i.test(name);
  const isImage = mime.startsWith('image/') || /\.(png|jpe?g|webp|gif|bmp)($|\?)/i.test(src) || /\.(png|jpe?g|webp|gif|bmp)$/i.test(name);
  return <Modal open onClose={onClose} title={name} max={980} titleRight={<Button size="sm" variant="secondary" icon="download" onClick={() => { const a = document.createElement('a'); a.href = src; a.download = name; document.body.appendChild(a); a.click(); a.remove(); }}>{t('pay.download')}</Button>} footer={<Button onClick={onClose}>{t('pay.close')}</Button>}>
    {isPdf && typeof PdfViewer === 'function'
      ? <PdfViewer src={src} name={name} />
      : isImage
        ? <div className="ans-attachment-preview"><img src={src} alt={name} /></div>
        : <div className="pdfv-msg"><Icon name="fileText" size={28} /><b>{name}</b><span className="muted" style={{ fontWeight: 600 }}>{t('pay.cannotPreview')}</span><a className="btn btn-secondary btn-sm" href={src} target="_blank" rel="noopener noreferrer">{t('pay.openNewTab')}</a></div>}
  </Modal>;
}

function AnsattTravelsModal({ rows, onOpen, onClose }) {
  const [filter, setFilter] = React.useState('alle');
  const shown = rows.filter((entry) => filter === 'alle' || ansattStatusClass(entry.displayStatus || entry.status) === filter);
  const filters = [['alle',t('km.portal.all')],['warn',t('km.portal.sent')],['ok',t('km.portal.approved')],['payroll',t('km.portal.inPayroll')],['paid',t('pay.paidOut')],['err',t('km.portal.rejected')],['muted',t('km.portal.draft')]];
  return <Modal open onClose={onClose} title={t('pay.myTravel')} max={680} titleRight={<span className="t-sm muted" style={{ fontWeight: 700 }}>{t('emp.totalCount', { count: rows.length })}</span>} footer={<Button onClick={onClose}>{t('pay.close')}</Button>}>
    <div className="ans-exp-filters">{filters.map(([key, label]) => <button key={key} className={`bank-chip${filter === key ? ' on' : ''}`} onClick={() => setFilter(key)}>{label}<span className="bank-chip-n">{key === 'alle' ? rows.length : rows.filter((entry) => ansattStatusClass(entry.displayStatus || entry.status) === key).length}</span></button>)}</div>
    {shown.length ? <div className="col gap-10">{shown.map((travel) => <div data-app-control="true" key={travel.id} className="ans-list-row" onClick={() => onOpen && onOpen(travel)}>
      <span className="icon-chip" style={{ background: 'var(--panel)', flex: 'none' }}><Icon name="car" size={18} /></span>
      <div className="grow" style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 14 }}>{travel.purpose || t('emp.travelFallback')}</div><div className="t-sm muted" style={{ fontWeight: 600 }}>{ansattDate(travel.dateFrom)} - {ansattDate(travel.dateTo || travel.dateFrom)} - {travel.destination}</div></div>
      <AnsattPortalStatusPill status={travel.displayStatus || travel.status} />
      <Icon name="chevRight" size={18} className="muted" />
    </div>)}</div> : <div className="t-sm muted" style={{ fontWeight: 600 }}>{t('pay.noTravelInView')}</div>}
  </Modal>;
}

function AnsattPortalBottomNav({ view, onView }) {
  const items = [{ key: 'home', label: t('pay.home'), icon: 'home' }, { key: 'profile', label: t('pay.myPage'), icon: 'users' }];
  return <nav className="ans-mobile-nav" aria-label={t('pay.employeePortal')}>
    {items.map((item) => <button key={item.key} className={`ans-mobile-nav-item${view === item.key ? ' active' : ''}`} onClick={() => onView(item.key)}>
      <Icon name={item.icon} size={18} />
      <span>{item.label}</span>
    </button>)}
  </nav>;
}

function AnsattPortalPage({ onBack, setRoute, client, setClient }) {
  const [refreshKey, setRefreshKey] = React.useState(0);
  const [selectedKey, setSelectedKey] = React.useState(() => window.getRememberedEmployeePortal?.() || '');
  const [view, setView] = React.useState('home');
  const [form, setForm] = React.useState('');
  const [listModal, setListModal] = React.useState('');
  const [timerOpen, setTimerOpen] = React.useState(false);
  const [activeTravel, setActiveTravel] = React.useState(null);
  const [bg, setBg] = React.useState('default');
  const [activeYear, setActiveYear] = React.useState(new Date().getFullYear());
  const portals = useAnsattPortals(refreshKey);
  const rows = portals.rows || [];
  const selected = rows.find((portal) => `${portal.businessId}-${portal.employee?.id}` === selectedKey) || rows[0] || null;
  const allPayslips = Array.isArray(selected?.payrollRuns) ? selected.payrollRuns : [];
  const allExpenses = Array.isArray(selected?.expenses) ? selected.expenses : [];
  const allTravels = Array.isArray(selected?.travels) ? selected.travels : [];
  const availableYears = selected ? ansattEmploymentYears(selected.employee, [
    ...allPayslips.map((row) => [row, ['paymentDate', 'period']]),
    ...allExpenses.map((row) => [row, ['date']]),
    ...allTravels.map((row) => [row, ['dateFrom', 'submittedAt']]),
  ]) : [new Date().getFullYear()];
  const clients = typeof window.getClients === 'function' ? window.getClients() : [];
  const selectEmployer = (key) => {
    setSelectedKey(key);
    window.rememberEmployeePortal?.(key);
  };
  const goToClient = (businessId) => {
    if (businessId && setClient) setClient(businessId);
    if (setRoute) setRoute('hjem');
    else if (onBack) onBack();
  };
  const routeFromProfile = (nextRoute) => {
    if (nextRoute === 'ansattportal') {
      setView('home');
      return;
    }
    setRoute && setRoute(nextRoute);
  };
  React.useEffect(() => {
    if (selected && !selectedKey) selectEmployer(`${selected.businessId}-${selected.employee?.id}`);
  }, [selected?.businessId, selected?.employee?.id]);
  React.useEffect(() => {
    if (!availableYears.includes(activeYear)) setActiveYear(availableYears[0] || new Date().getFullYear());
  }, [availableYears.join('|'), activeYear]);
  React.useEffect(() => {
    if (!selected?.businessId) return undefined;
    const key = getAnsattBg(selected.businessId);
    setBg(key);
    if (key && key !== 'default') document.documentElement.dataset.bg = key; else delete document.documentElement.dataset.bg;
    return () => { delete document.documentElement.dataset.bg; };
  }, [selected?.businessId]);
  const refresh = () => { setForm(''); setRefreshKey((key) => key + 1); };

  if (portals.loading) return <Card><EmptyState noVisual title={t('pay.fetchingPortal')} text={t('emp.connectingEmployers')} /></Card>;
  if (portals.error) return <Card><EmptyState noVisual title={t('pay.portalFailed')} text={portals.error} action={onBack ? <Button variant="secondary" onClick={onBack}>{t('pay.back')}</Button> : null} /></Card>;
  if (!selected) return <Card><EmptyState noVisual title={t('pay.noEmployers')} text={t('emp.noActiveAccess')} action={onBack ? <Button variant="secondary" onClick={onBack}>{t('pay.back')}</Button> : null} /></Card>;

  const payslips = allPayslips.filter((row) => ansattRowYear(row, ['paymentDate', 'period']) === activeYear);
  const expenses = allExpenses.filter((row) => ansattRowYear(row, ['date']) === activeYear);
  const travels = allTravels.filter((row) => ansattRowYear(row, ['dateFrom', 'submittedAt']) === activeYear);
  const timeEntries = Array.isArray(selected.timeEntries) ? selected.timeEntries : [];
  const monthPrefix = `${activeYear}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
  const monthEntries = timeEntries.filter((entry) => String(entry.date || '').startsWith(monthPrefix));
  const monthHours = monthEntries.reduce((sum, entry) => sum + (Number(entry.hours) || 0), 0);
  const hoursThisMonth = { count: monthEntries.length, label: t('pay.hoursThisMonth', '{time} denne måneden', { time: window.PlummeProjectTimeTracking.formatHours(monthHours) }) };
  const employeeName = selected.employee?.name || t('emp.employeeFallback');
  const activeKey = `${selected.businessId}-${selected.employee?.id}`;
  return <div className="ans-portal ans-client-layout">
    <aside className="ans-side">
      <div className="ans-side-brand">Plumme</div>
      <AnsattEmployerSwitcher rows={rows} selected={selected} onSelect={selectEmployer} clients={clients} activeClientId={client} onSelectClient={goToClient} />
      <div className="ans-side-label">{t('pay.employee')}</div>
      <nav className="ans-side-nav">
        <button className={`ans-side-item${view === 'home' ? ' active' : ''}`} onClick={() => setView('home')} data-help-title={t('pay.home')} data-help={t('pay.homeHelp')}><Icon name="home" size={18} />{t('pay.home')}</button>
        <button className={`ans-side-item${view === 'profile' ? ' active' : ''}`} onClick={() => setView('profile')} data-help-title={t('pay.myPage')} data-help={t('pay.myPageHelp')}><Icon name="users" size={18} />{t('pay.myPage')}</button>
      </nav>
    </aside>

    <section className="ans-workspace">
      <header className="ans-top">
        <div />
        <div className="row gap-12" style={{ alignItems: 'center' }}>
          <label className="ans-year">
            <Select value={activeYear} onChange={(event) => setActiveYear(Number(event.target.value))}>
              {availableYears.map((year) => <option key={year} value={year}>{year}</option>)}
            </Select>
          </label>
          <DarkToggle/><AnsattColor businessId={selected.businessId} value={bg} onPick={(key) => {
            setBg(key);
            if (key && key !== 'default') document.documentElement.dataset.bg = key; else delete document.documentElement.dataset.bg;
          }} />
          {onBack && <button className="ans-logout" onClick={onBack}>{t('pay.signOut')}</button>}
        </div>
      </header>

      <div className="ans-body">
        {view === 'profile' && window.MinSidePage ? <window.MinSidePage setRoute={routeFromProfile} client={client} setClient={setClient} /> : <React.Fragment>
          <div className="ans-pagehead"><div className="ans-kicker">{t('pay.employee')}</div><div className="ans-title" data-help-title={t('pay.myEmployeePage')} data-help={t('pay.myEmployeePageHelp')}>{t('pay.home')}</div></div>
          <Card className="ans-employer">
            <div className="ans-person"><b>{employeeName}</b><span>{selected.employee?.jobTitle || t('emp.employeeFallback')}</span><span>{selected.employee?.email}</span></div>
            <div className="ans-field-static" data-help-title={t('pay.employer')} data-help={t('pay.employerHelp')}>
              <label>{t('pay.employer')}</label>
              <Select value={activeKey} onChange={(event) => selectEmployer(event.target.value)}>
                {rows.map((portal) => <option key={`${portal.businessId}-${portal.employee?.id}`} value={`${portal.businessId}-${portal.employee?.id}`}>{portal.businessName}</option>)}
              </Select>
            </div>
          </Card>

          <div className="ans-stats">
            <AnsattMetric title={t('pay.payslips')} value={payslips.length} tint="green" help={t('pay.payslipsHelp')} sub={payslips.length ? t('emp.payslipsAvailable', { count: payslips.length }) : t('emp.noPayslipsReady')} onClick={payslips.length ? () => setListModal('payslips') : undefined} />
            <AnsattMetric title={t('pay.myExpenses')} value={expenses.length} tint="peach" help={t('pay.expensesHelp')} sub={t('emp.pendingApprovedSummary', { pending: expenses.filter((entry) => ansattStatus(entry.displayStatus || entry.approvalStatus || entry.status)[2] === 'sent').length, approved: expenses.filter((entry) => ansattStatus(entry.displayStatus || entry.approvalStatus || entry.status)[2] === 'approved').length })} onClick={expenses.length ? () => setListModal('expenses') : undefined} />
            <AnsattMetric title={t('pay.myTravel')} value={travels.length} tint="plum" help={t('pay.travelHelp')} sub={t('emp.pendingApprovedSummary', { pending: travels.filter((entry) => ansattStatus(entry.displayStatus || entry.status)[2] === 'sent').length, approved: travels.filter((entry) => ansattStatus(entry.displayStatus || entry.status)[2] === 'approved').length })} onClick={travels.length ? () => setListModal('travels') : undefined} />
            {/* Timekortet vises bare der arbeidsgiveren faktisk bruker prosjekter. */}
            {(selected.projects || []).length > 0 && <AnsattMetric title={t('pay.myHours', 'Mine timer')} value={hoursThisMonth.count} tint="green" help={t('pay.hoursHelp', 'Timene du har fort pa prosjekt.')} sub={hoursThisMonth.label} onClick={() => setTimerOpen(true)} />}
          </div>

          {selected.readOnly ? <div className="alert alert-info"><span className="alert-ico"><Icon name="info" size={18} /></span><span>{t('pay.portalEmploymentEnded')}</span></div> : <div className="ans-actions">
            {(selected.projects || []).length > 0 && window.AnsattTimerModal && <Button size="lg" variant="secondary" icon="clock" onClick={() => setTimerOpen(true)}>{t('pay.registerHours', 'Fore timer')}</Button>}
            <Button size="lg" icon="receipt" onClick={() => setForm('expense')} data-help-title={t('pay.registerExpense')} data-help={t('pay.registerExpenseHelp')}>{t('pay.registerExpense')}</Button>
            <Button size="lg" variant="secondary" icon="car" onClick={() => setForm('mileage')}>{t('km.flow.portalLog')}</Button>
            <Button size="lg" variant="secondary" icon="car" onClick={() => setForm('travel')} data-help-title={t('pay.registerTravel')} data-help={t('pay.registerTravelHelp')}>{t('pay.registerTravel')}</Button>
          </div>}
        </React.Fragment>}
      </div>

    {form === 'expense' && <AnsattExpenseForm portal={selected} onClose={() => setForm('')} onSaved={refresh} />}
    {form === 'mileage' && <AnsattMileageLog portal={selected} onClose={()=>setForm('')} onOpen={travel=>{setForm('');setActiveTravel(travel);}}/>}
    {form === 'travel' && <AnsattTravelCreateForm portal={selected} onClose={() => setForm('')} onCreate={(travel) => { setForm(''); setActiveTravel(travel); }} />}

    </section>
    {listModal === 'payslips' && <AnsattPayslipsModal rows={payslips} onClose={() => setListModal('')} />}
    {listModal === 'expenses' && <AnsattExpensesModal rows={expenses} portal={selected} onClose={() => setListModal('')} onDeleted={refresh} />}
    {listModal === 'travels' && <AnsattTravelsModal rows={travels} onOpen={(travel) => { setListModal(''); setActiveTravel(travel); }} onClose={() => setListModal('')} />}
    {timerOpen && window.AnsattTimerModal && <window.AnsattTimerModal portal={selected} onClose={() => setTimerOpen(false)} onSaved={refresh} />}
    {activeTravel && <AnsattTravelDetailModal travel={activeTravel} portal={selected} onClose={() => setActiveTravel(null)} onUpdate={setActiveTravel} onSaved={() => { setActiveTravel(null); refresh(); }} />}
    <AnsattPortalBottomNav view={view} onView={setView} />
  </div>;
}

Object.assign(window, { AnsattPortalPage, AnsattAttachmentBlobPreviewModal });
